import type { SENTRY_INIT_STEPS, SentryInitEvent, SentryStateMachine } from '../types';

import { INIT_STEPS } from '../config';

let sentryInitMachine: SentryStateMachine | null = null;

/**
 * Singleton creator for the Sentry state machine to manage the init step status.
 *
 * This is only useful for checking the Sentry init state on the **client**.
 *
 * @example
 * ```ts
 * const sentryInitMachine = createSentryStateMachine();
 * if (sentryInitMachine?.CURRENT() === INIT_STEPS.INITIALIZED) {
 *   // do something that needs sentry initialized
 * }
 * ```
 */
export function createSentryStateMachine(): SentryStateMachine {
	if (sentryInitMachine != null) {
		return sentryInitMachine;
	}

	let INIT_STEP: SENTRY_INIT_STEPS = INIT_STEPS.COLD;

	function CURRENT() {
		return INIT_STEP;
	}

	function on(event: SentryInitEvent): void {
		switch (event.type) {
			case INIT_STEPS.COLD:
				if (INIT_STEP === INIT_STEPS.COLD) INIT_STEP = INIT_STEPS.INITIALIZING;
				return;

			case INIT_STEPS.INITIALIZING: {
				if (INIT_STEP === INIT_STEPS.COLD) INIT_STEP = INIT_STEPS.INITIALIZING;
				return;
			}

			case INIT_STEPS.INITIALIZED:
				if (INIT_STEP === INIT_STEPS.INITIALIZING) INIT_STEP = INIT_STEPS.INITIALIZED;
				return;

			case INIT_STEPS.FAILED:
				INIT_STEP = INIT_STEPS.FAILED;
				console.error('Sentry initialization failed:', event.error);
				return;
		}
	}

	return (sentryInitMachine = { CURRENT, on });
}
